import type * as React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'

import { Text } from '@buffer-mono/popcorn'

import { ImagesLayout } from './ImagesLayout'
import styles from './SearchImages.module.css'
import type { GraphImage, IntegrationsService } from '../../types'

import type { JSX } from 'react'

const MAX_WINDOW_SIZE = 10

export const SearchImagesResults = ({
  images = [],
  getMore,
  loading,
  loader,
  service,
}: {
  images: GraphImage[]
  getMore: () => void
  loading: boolean
  loader: React.ReactElement
  service: IntegrationsService
}): JSX.Element => {
  if (images?.length === 0 && loading) {
    return loader
  }

  if (images?.length === 0 && !loading) {
    return (
      <div className={styles.noResultsLayout}>
        <Text as="h3" className={styles.noResultsText}>
          No results for that search
        </Text>
        <Text as="p" className={styles.noResultsText}>
          Try again with another word
        </Text>
      </div>
    )
  }

  return (
    <div className={styles.masonryContainer} id="scrollableContainer">
      <InfiniteScroll
        dataLength={images ? images.length : 0}
        hasMore={images.length >= MAX_WINDOW_SIZE}
        next={getMore}
        loader={loader}
        scrollableTarget="scrollableContainer"
      >
        <ImagesLayout images={images} service={service} />
      </InfiniteScroll>
    </div>
  )
}
